import { render, staticRenderFns } from "./Authorization.vue?vue&type=template&id=45f970b3&scoped=true&"
import script from "./Authorization.vue?vue&type=script&lang=js&"
export * from "./Authorization.vue?vue&type=script&lang=js&"
import style0 from "./Authorization.vue?vue&type=style&index=0&id=45f970b3&scoped=true&lang=css&"
import style1 from "./Authorization.vue?vue&type=style&index=1&id=45f970b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f970b3",
  null
  
)

export default component.exports